import React, {useState} from "react";
import { ExcelForm } from "../components/UI/reusable-components/ExcelProductPageComponents/ExcelForm";
import  ExcelUploader  from "../components/UI/reusable-components/ExcelProductPageComponents/ExcelUploader";
import { ExcelGrid } from "../components/UI/reusable-components/ExcelProductPageComponents/ExcelGrid";
import {Box} from "@mui/material"
import { ThemeContext } from "@emotion/react";

export const  ExcelProductPage =  () => {

    return(
    <Box sx={{display:'flex', flexDirection: { xs: 'column', md: 'row' }}}>
        <Box>
        <ExcelForm/>   
        <ExcelUploader onFilesChange={(files) => console.log(files)} />
        </Box>
    <ExcelGrid/>
    </Box>)
}
